var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M3.24639 0.954102C1.98206 0.954102 0.954117 1.98204 0.954117 3.24637V14.7077C0.954117 15.9721 1.98206 17 3.24639 17H14.7077C15.9721 17 17 15.9721 17 14.7077V3.24637C17 1.98204 15.9721 0.954102 14.7077 0.954102H3.24639ZM8.11746 12.1289V9.83665H5.82519C5.34883 9.83665 4.96559 9.45341 4.96559 8.97705C4.96559 8.50069 5.34883 8.11745 5.82519 8.11745H8.11746V5.82518C8.11746 5.34881 8.5007 4.96558 8.97707 4.96558C9.45343 4.96558 9.83667 5.34881 9.83667 5.82518V8.11745H12.1289C12.6053 8.11745 12.9885 8.50069 12.9885 8.97705C12.9885 9.45341 12.6053 9.83665 12.1289 9.83665H9.83667V12.1289C9.83667 12.6053 9.45343 12.9885 8.97707 12.9885C8.5007 12.9885 8.11746 12.6053 8.11746 12.1289Z",
          fill: "#010A11",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }